import axios from "axios";
import { useStaticQuery, graphql } from "gatsby";
import { isEmpty } from "lodash"

export const GetURL = (url) => {

  const data = useStaticQuery(graphql`
    query {
	  allStrapiAllMenus {
	    edges {
	      node {
	        Alias
	        Label
	        URL
	        Main_Parent {
	          Alias
	          Label
	          URL
	        }
	        Sub_Parent {
	          Alias
	          Label
	          URL
	        }
	      }
	    }
	  }
    }
  `);
  
  if (url) {
    return url;
  }
}

export const isSold = (status='') => {
	const soldSTatus = ['sold', 'sold sstc', 'let', 'let agreed'];
	return soldSTatus.includes(status.toLowerCase());
}
export const isSoldOnly = (status='') => {
	const soldSTatus = status === "Sold" ? true : false ; 
	return soldSTatus;
}

export const isNotAvailble = (status='') => {
	const soldSTatus = (status === "Sold" || status === "Let" || status === "Let Agreed" || status === "Sold STC") ? true : false ; 
	return soldSTatus;
}
export const getitems = async ({url, setTestimonials}) => {
    try {
      const { data } = await axios.get(url, {
		headers: {
			Authorization:
				`Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
		}
	  }) // could be from env files
      setTestimonials(data)
    } catch (error) {
      // cache it if fail/error;
      console.error(error)
    }
}

export const removeSpecialChar = (val, symbol = '-') => {
    if (!isEmpty(val)) {
      return val.replace(/[^\w\s]/gi, ' ').replace(/\s\s+/g, ' ').replace(/ /gi, symbol).toLowerCase()
    }
    return val;
  }